import axios from 'axios';
import router from '@/router';
axios.defaults.baseURL = '';
axios.defaults.timeout = 60 * 1000;
axios.defaults.withCredentials = true;
/**
 *  再在 request 拦截器实现, 传给后台的
 * -----------------------------------
 */

axios.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem('token');
        token && (config.headers.Authorization = 'Bearer ' + token);
        const lang = localStorage.getItem('language') || 'zh';
        config.headers.lang = lang;
        config.headers['Accept-Language'] = lang;

        if (config.url && (
            config.url.indexOf('/api/doge/') === 0 ||
            config.url.indexOf('/api/wallet/address/') === 0
        )) {
            const dogeToken = localStorage.getItem('doge_auth_token');
            if (dogeToken) config.headers['X-DOGE-AUTH'] = dogeToken;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

/**
 *  先在 response 拦截器实现, 拿后台返回的
 * --------------------------------
 */
axios.interceptors.response.use(
    (response) => {
        const code = response && response.data && String(response.data.code);
        if (code === '999' || code === '401') {
            const isDogeAuthApi = response.config && response.config.url && (
                response.config.url.indexOf('/api/doge/') === 0 ||
                response.config.url.indexOf('/api/wallet/address/') === 0
            );
            if (isDogeAuthApi) {
                localStorage.removeItem('doge_auth_token');
            } else {
                localStorage.removeItem('token');
                if (router.currentRoute.path !== '/') window.location.replace('/');
            }
        }
        return response;
    },
    (error) => {
        const status = error && error.response && error.response.status;
        if (status === 401 || status === 403) {
            const isDogeAuthApi = error.config && error.config.url && (
                error.config.url.indexOf('/api/doge/') === 0 ||
                error.config.url.indexOf('/api/wallet/address/') === 0
            );
            if (isDogeAuthApi) {
                localStorage.removeItem('doge_auth_token');
            } else {
                localStorage.removeItem('token');
                if (router.currentRoute.path !== '/') window.location.replace('/');
            }
        }
        return Promise.reject(error);
    }
);

export default axios;
